import {
  TapTrainingPlanViewMngSnglTeamCurriculumFltrReducer,
  TapTrainingPlanViewMngSnglTeamTrainingFltrReducer,
  TapTrainingPlanViewMngSnglTeamWWIDFltrReducer,
} from 'TAP/redux/reducers/filterTrainingPlanViewMngerSnglTeamReducers';
import {
  TrainingViewIndividualUserReducer,
  TrainingViewIndividualUserSearchSuggestionsReducer,
} from 'TAP/redux/reducers/trainingViewIndividualUserReducer';

import { FilterMyOrgReducer } from 'TAP/redux/reducers/filterMyOrgReducer';
import { FilterPopUpDetailsReducer } from 'TAP/redux/reducers/filterPopUpDetailsReducer';
import { FilterDirectReporteeActionPopUpDetailsReducer } from 'TAP/redux/reducers/filterPopUpDirectReporteeActionReducer';
import { FilterDirectReporteeTrainingPopUpDetailsReducer } from 'TAP/redux/reducers/filterPopUpDirectReporteeTrainingReducer';
import { MyOrgTrainingCompletionReducer } from 'TAP/redux/reducers/myOrgTrainingCompletionReducer';
import { MyDirectTrainingCompletionReducer } from 'TAP/redux/reducers/myDirectTrainingCompletionReducer';
import { MyOrgComplianceProfileReducer } from 'TAP/redux/reducers/myOrgComplianceProfileReducer';
import { MyDirectReporteeComplianceProfileReducer } from 'TAP/redux/reducers/myDirectReporteeComplianceProfileReducer';
import { PopUpDetailsReducer } from 'TAP/redux/reducers/popUpDetailsReducer';
import { DirectReporteePopUpDetailsReducer } from 'TAP/redux/reducers/directRporteePopUpDetailsReducer';
import { PopUpReminderReducer } from 'TAP/redux/reducers/popUpReminderReducer';
import { TapManagerSingleTeamFilterReducer } from 'TAP/redux/reducers/filterManagerSingleTeamReducer';
import { TapManagerSingleTeamReducer } from 'TAP/redux/reducers/managerSingleTeamReducer';
import { TapTrainingPlanViewDirectReporteeMrgSnglTeamReducer } from 'TAP/redux/reducers/trainingPlanViewDRMngSinglTeamReducer';
import { TapUserDetailsReducer } from 'TAP/redux/reducers/tapUserDetailsReducer';
import { TeamPerformanceReducer } from 'TAP/redux/reducers/teamPerformanceReducer';
import { TeamPerformanceDirectReducer } from 'TAP/redux/reducers/teamPerformanceDirectReducer';
import { AdminReducer } from 'TAP/redux/reducers/AdminReducer';
import { MyOrgComplianceActionsReducer } from 'TAP/redux/reducers/myOrgComplianceActionsReducer';
import { DirectReporteeComplianceActionsReducer } from 'TAP/redux/reducers/directReporteeComplianceActionReducer';
import { ThemeSwitcherReducer } from './themeSwitcherReducer';
import { TrainingMetricsReducer } from 'TAP/redux/reducers/trainingMetricsReducer';
import { TrainingPlanPopupReducer } from 'TAP/redux/reducers/trainingPlanPopupReducer';
import { AdminViewCompleteStatReducer } from 'TAP/redux/reducers/adminViewCSReducer';
import { AdminComplianceProfileReducer } from 'TAP/redux/reducers/adminComplianceProfileReducer';
import { AdminComplianceActionsReducer } from 'TAP/redux/reducers/adminComplianceActionsReducer';
import { AdminPopUpDetailsReducer } from 'TAP/redux/reducers/adminPopUpDetailsReducer';
import { AdminFilterPopUpDetailsReducer } from 'TAP/redux/reducers/adminFilterPopUpDetailsReducer';
import { myPerformanceComplianceStatusReducer } from 'TAP/redux/reducers/myPerformanceCSReducer';
import { combineReducers } from 'redux';
import { AdminQuickFilterReducer } from 'TAP/redux/reducers/adminQuickFilterReducer';
import { AdminFavouriteFilterReducer } from 'TAP/redux/reducers/adminFavouriteFilterReducer';
import { AdminShareFavouriteReducer } from 'TAP/redux/reducers/adminShareFavouriteReducer';
import { AdminSharedWithFiltersReducer } from 'TAP/redux/reducers/adminSharedWithFiltersReducer';
import { AdminDeleteSharedFavouriteReducer } from 'TAP/redux/reducers/adminDeleteSharedFavouriteReducer';
import { AdminListToShareFavWithReducer } from 'TAP/redux/reducers/adminListToShareFavWithReducer';
import {
  AdminManageFilterListReducer,
  AdminManageFilterLoadReducer,
  AdminManageFilterDeleteReducer,
} from 'TAP/redux/reducers/adminManageFilterReducer';
import {
  LargeReportDownloadReducer,
  ReportDownloadReducer,
} from 'TAP/redux/reducers/teamsPerformanceDownloadReducer';
import { AdminLargeReportDownloadReducer } from 'TAP/redux/reducers/adminLargeReportDownloadReducer';
import { UniversalDashboardReducer } from 'TAP/redux/reducers/universalDashboardReducer';
import { AlertReducer } from 'TAP/redux/reducers/alertReducer';
import { CommonActionsReducer } from 'TAP/redux/reducers/commonActionsReducer';
import { MyTeamsProfileDepartmentReducer } from 'TAP/redux/reducers/UserProfileReducers/myTeamsProfileDepartmentReducer';
import { MyTeamProfileReducer } from 'TAP/redux/reducers/UserProfileReducers/myTeamProfileReducer';
import { MyTeamsProfileDepartmentFilterReducer } from 'TAP/redux/reducers/UserProfileReducers/myTeamsProfileDepartmentFilterReducer';
import { MyProfileJobRoleDetailsReducer } from 'TAP/redux/reducers/UserProfileReducers/myProfileJobRoleDetailsReducer';
import { myTeamProfile100KDownloadDetailsReducer } from 'TAP/redux/reducers/UserProfileReducers/myTeamProfile100KDownloadReducer';
import { DelegateUserReducer } from 'TAP/redux/reducers/delegateUserReducers';
import { PollingCounterReducer } from 'TAP/redux/reducers/downloadPollingReducer';

export const RootReducer = () =>
  combineReducers({
    themeSwitcherRd: ThemeSwitcherReducer,
    tapUserDetailsRd: TapUserDetailsReducer,
    trainingMetricsRd: TrainingMetricsReducer,
    teamPerformanceRd: TeamPerformanceReducer,
    teamPerformanceDirectRd: TeamPerformanceDirectReducer,
    adminRd: AdminReducer,
    myOrgTrainingCompletionRd: MyOrgTrainingCompletionReducer,
    myDirectTrainingCompletionRd: MyDirectTrainingCompletionReducer,
    myOrgComplianceProfileRd: MyOrgComplianceProfileReducer,
    MyDirectReporteeComplianceProfileRd: MyDirectReporteeComplianceProfileReducer,
    myOrgComplianceActionsRd: MyOrgComplianceActionsReducer,
    directReporteeComplianceActionsRd: DirectReporteeComplianceActionsReducer,
    filterMyOrgTrainingsRd: FilterMyOrgReducer,
    tapManagerSingleTeamReducerRd: TapManagerSingleTeamReducer,
    tapManagerSingleTeamFilterRd: TapManagerSingleTeamFilterReducer,
    tapPopUpDetailsRd: PopUpDetailsReducer,
    tapDirectReporteePopUpDetailsRd: DirectReporteePopUpDetailsReducer,
    tappopUpFilterRd: FilterPopUpDetailsReducer,
    directReporteeActionpopUpFilterRd: FilterDirectReporteeActionPopUpDetailsReducer,
    directReporteeTrainingpopUpFilterRd: FilterDirectReporteeTrainingPopUpDetailsReducer,
    tapPopUpReminder: PopUpReminderReducer,
    trainingViewIndividualUserRd: TrainingViewIndividualUserReducer,
    universalDashboardReducer: UniversalDashboardReducer,
    trainingViewIndividualUserSearchSuggestionsRd:
      TrainingViewIndividualUserSearchSuggestionsReducer,
    tapTrainingPlanPopupRd: TrainingPlanPopupReducer,
    teamsPerformanceDownloadReducer: ReportDownloadReducer,
    teamsPerformanceLargeDownloadReducer: LargeReportDownloadReducer,
    adminLargeReportDownloadRd: AdminLargeReportDownloadReducer,
    tapTrainingPlanViewDirectReporteeMrgSnglTeamRd:
      TapTrainingPlanViewDirectReporteeMrgSnglTeamReducer,
    tapAdminViewCompleteStatusRd: AdminViewCompleteStatReducer,
    tapTrainingPlanViewMngSnglTeamWWIDFltrRd: TapTrainingPlanViewMngSnglTeamWWIDFltrReducer,
    tapTrainingPlanViewMngSnglTeamCurriculumFltrRd:
      TapTrainingPlanViewMngSnglTeamCurriculumFltrReducer,
    tapTrainingPlanViewMngSnglTeamTrainingFltrRd: TapTrainingPlanViewMngSnglTeamTrainingFltrReducer,
    adminComplianceProfileRd: AdminComplianceProfileReducer,
    adminComplianceActionsRd: AdminComplianceActionsReducer,
    tapAdminPopUpDetailsRd: AdminPopUpDetailsReducer,
    adminPopUpFilterRd: AdminFilterPopUpDetailsReducer,
    myPerformanceComplianceStatusRd: myPerformanceComplianceStatusReducer,
    adminQuickFilterRd: AdminQuickFilterReducer,
    adminFavouriteFilterRd: AdminFavouriteFilterReducer,
    adminShareFavouriteRd: AdminShareFavouriteReducer,
    adminSharedWithFiltersRd: AdminSharedWithFiltersReducer,
    adminDeleteSharedFavouriteRd: AdminDeleteSharedFavouriteReducer,
    adminListToShareFavWithRd: AdminListToShareFavWithReducer,
    adminManageFilterListRd: AdminManageFilterListReducer,
    adminManageFilterLoadRd: AdminManageFilterLoadReducer,
    adminManageFilterDeleteRd: AdminManageFilterDeleteReducer,
    myTeamsProfileDepartmentRd: MyTeamsProfileDepartmentReducer,
    myTeamsProfileDepartmentFilterRd: MyTeamsProfileDepartmentFilterReducer,
    MyProfileJobRoleDetailsRd: MyProfileJobRoleDetailsReducer,
    MyTeamProfile100KDownloadDetailsRd: myTeamProfile100KDownloadDetailsReducer,
    alertRd: AlertReducer,
    delegateUserRd: DelegateUserReducer,
    commonRd: CommonActionsReducer,
    myTeamProfileRd: MyTeamProfileReducer,
    pollingCounterRd: PollingCounterReducer,
    router: '', //connectRouter(history),
  });
